import React, { useState, useEffect } from 'react'
import './SignUp.css'
import { Button } from '@mui/material'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { validateEmail } from '../../utils/utils';
import { Link } from 'react-router-dom';
import GoogleLogo from "../../assets/google-logo.png"
import GitLogo from "../../assets/git-logo.png"
import { connect } from 'react-redux';
import { connectWithGoogle, connectWithGithub, signUp } from '../../store/actions/AuthActions';
import { useNavigate } from 'react-router-dom';
import { anonymousEmailList } from '../../utils/anonymous';
import AuthRight from '../AuthRight/AuthRight';


function SignUp({ state, connectWithGoogle, connectWithGithub, storeSignUp }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [name, setName] = useState('');
    const nav = useNavigate();
    useEffect(() => {
        if (state.isAuthenticated) {
            nav('/dashboard');
        }
    }, [state, nav]);
    useEffect(()=>{
        document.title ="Blockery Web App || Sign Up"
    })
    const signup = () => {
        if (password && email && name) {
            if (name.length < 3) {
                toast.error(`Name shouldn't be less than 3 characters`)
            }
            if (password !== confirmPassword) {
                toast.error('Passwords do not match')
            } else if (password.length < 6) {
                toast.error('Password must be at least 6 characters')
            }
            else if (!validateEmail(email)) {
                toast.error('Please enter a valid email')
            }
            else {
                // find email domain
                const emailDomain = email.split('@');
                if (anonymousEmailList.includes(emailDomain[emailDomain.length - 1])) {
                    toast.error('Please enter a valid email')
                } else {
                    storeSignUp({ email, password, name })
                }
            }
        }
        else {
            toast.error('Please fill out all fields')
        }
    }
    return (
        <div className='auth-container'>
            <ToastContainer pauseOnHover autoClose={2000} />
            <AuthRight />
            <div data-aos="zoom-in" data-aos-duration="500" className='auth-container-left' >
                <h3>Hello Again!</h3>
                <p>Sign Up to get started</p>
                <input placeholder='Name' type="text" className='auth-input' onChange={(e) => setName(e.target.value)}></input>
                <input placeholder='Email' type="email" className='auth-input' onChange={(e) => setEmail(e.target.value)}></input>
                <input placeholder='Password' type="password" className='auth-input' onChange={(e) => setPassword(e.target.value)} />
                <input placeholder='Confirm Password' type="password" className='auth-input' onChange={(e) => setConfirmPassword(e.target.value)} />
                <Button className='auth-btn' onClick={() => signup()}>SignUp</Button>
                <p>Already have an account? <Link to="/login" style={{ textDecoration: "none" }}><Button>Login</Button></Link></p>
                <Button onClick={() => connectWithGoogle()} className="auth-btn">
                    <img src={GoogleLogo} alt="google-logo" className='google-logo' />
                    Login with Google
                </Button>
                <Button onClick={() => connectWithGithub()} className="auth-btn">
                    <img src={GitLogo} alt="google-logo" className='google-logo' />
                    Login with GitHub
                </Button>
            </div>
        </div>
    )
}
const mapStateToProps = state => {
    return {
        state: state.AuthServicesList
    }
}
const mapDispatchToProps = dispatch => {
    return {
        connectWithGoogle: () => dispatch(connectWithGoogle()),
        connectWithGithub: () => dispatch(connectWithGithub()),
        storeSignUp: (body) => dispatch(signUp(body))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SignUp)